module.exports = __webpack_public_path__ + "static/img_p2-13789189c58d5f3e188d5bca53cd7228.jpg";